// #tag: CLIENT ENTRYPOINT AND CONTEXT PROVIDER COMPOSITION
// #purpose: Mounts the React root element and wraps the app with QueryClient, React Router, Appearance, and Auth providers.
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AppearanceProvider } from './context/AppearanceProvider';
import { AuthProvider, SavedExamsProvider } from './context/AuthProvider';

// #tag: REACT QUERY CLIENT CONFIGURATION
// #purpose: Configures client-side caching, background refetching, and stale time policies for server queries.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 60_000, retry: 1 },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// #tag: DOM ROOT RENDERER
// #purpose: Bootstraps the top-level React component tree into the index.html root container.
root.render(
  <React.StrictMode>
    <AppearanceProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <AuthProvider>
            <SavedExamsProvider>
              <App />
            </SavedExamsProvider>
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </AppearanceProvider>
  </React.StrictMode>,
);
